import React, { useEffect } from 'react';
import { Modal, Form, Select, InputNumber, Input } from 'antd';
import { connect } from 'react-redux';

const { Option } = Select;

const DownTimeModal = ({
  visible,
  onCancel,
  onOk,
  downtimeEquipments,
  onFetchDowntimeEquipments,
  projectId,
  loading,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (projectId) {
      onFetchDowntimeEquipments({ projectId });
    }
  }, [projectId, onFetchDowntimeEquipments]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onOk(values);
        form.resetFields();
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const downtimeTypes = [
    { id: 1, name: 'Quality' },
    { id: 2, name: 'Equipment' },
    { id: 3, name: 'Weather' },
    { id: 4, name: 'Operations' },
    { id: 5, name: 'Contractor' },
  ];

  return (
    <Modal
      visible={visible}
      title="Add Downtime Entry"
      onCancel={onCancel}
      onOk={handleOk}
      okText="OK"
      cancelText="Cancel"
      destroyOnClose
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="downtimeType" label="Type" rules={[{ required: true }]}>
          <Select placeholder="Select a type" className="client-select">
            {downtimeTypes.map((type) => (
              <Option key={type.id} value={type.id}>
                {type.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="pihEquipmentId" label="Equipment" rules={[{ required: true }]}>
          <Select
            placeholder="Select Equipment"
            className="client-select"
            showSearch
            filterOption={(input, option) =>
              option.children[0].toLowerCase().includes(input.toLowerCase())
            }
          >
            {downtimeEquipments.map((eq) => (
              <Option key={eq.id} value={eq.id}>
                {eq.pihEquipmentType}
                <br />
                <small>{eq.serialNumber}</small>
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="coatingDowntime"
          label="Coating Downtime (Minutes)"
          rules={[{ required: true }]}
        >
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          name="contractorDowntime"
          label="Contractor Downtime (Minutes)"
          rules={[{ required: true }]}
        >
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="comments" label="Comments">
          <Input.TextArea />
        </Form.Item>
        <Form.Item name="issues" label="Issue">
          <Input.TextArea />
        </Form.Item>
        <Form.Item name="actionTaken" label="Action Taken">
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const mapStateToProps = ({ dsrReducer }) => ({
  downtimeEquipments: dsrReducer.downtimeEquipments,
  loading: dsrReducer.isAddingDowntimeLogItem,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchDowntimeEquipments: (payload) =>
    dispatch({ type: '@@team/fetch-downtime-equipments', ...payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(DownTimeModal);
